import React from 'react';
import clsx from 'clsx';
import PopupTitle from '../PopupTitle';
import PopupContent from '../PopupContent';
import PopupActions from '../PopupActions';
import ButtonOutlined from '../Button/ButtonOutlined';
import TooltipDialogSC from './styles/TooltipDialogSC';
import factoryTooltip from './utils/factoryTooltip';
const RenderDialogTooltip = (props) => {
    const { title, content, actions, onActions, onClose, invertedBg } = props;
    const firstAction = actions[0];
    const onFirstAction = onActions[0];
    return (React.createElement("div", { className: "_ndsTooltip__content" },
        React.createElement(PopupTitle, Object.assign({ onClose: onClose }, (invertedBg && { darkMode: true })), title),
        React.createElement(PopupContent, Object.assign({}, (invertedBg && { darkMode: true })), content),
        firstAction && (React.createElement(PopupActions, null,
            React.createElement(ButtonOutlined, Object.assign({ onClick: onFirstAction, type: "button", compact: true }, (invertedBg && { darkMode: true })), firstAction)))));
};
const TooltipDialog = (props) => {
    const { title, content, actions, onActions, onClose, forwardedRef, rootStyle = {}, placement, arrowProps = {}, className: classNameProp, invertedBg } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement(TooltipDialogSC, { ref: forwardedRef, style: rootStyle, "data-placement": placement, className: clsx({
                '_ndsTooltip__inverted-bg': invertedBg
            }, '_ndsTooltip', classNameProp) },
            React.createElement(RenderDialogTooltip, { title: title, content: content, onClose: onClose, actions: actions, onActions: onActions, invertedBg: invertedBg }),
            React.createElement("div", { ref: arrowProps.ref, style: arrowProps.style, className: "_ndsTooltip__arrow" }))));
};
export default factoryTooltip(TooltipDialog, 'dialog');
//# sourceMappingURL=TooltipDialog.js.map